import React, { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import axios from 'axios';
import { Alert, Container } from "reactstrap";
import { AUTH_API_DOMAIN_URL } from "../common/constants";
import UserManualSearch from "../components/UserManualSearch";

const UserManual = (props) => {
	let view;
	let url = window.location.href;
	
	if(url.includes('employee')){
		view = 'employee'
	}
	else{
		view = (window.location.href.includes('admin') ? 'admin' : 'third_party') + '_' + props.activeModule;
	}

	const { lng, token } = props;

	const langId = props?.organization?.languages.find(l => l.language_code === lng)?.language?.id;

	const [content, setContent] = useState("");

	const fetchDoc = async () => {
		const response = await axios.get(`${AUTH_API_DOMAIN_URL}user_manual/get_context?view=${view}&language=${lng}`, token ? {
			headers: {
				Authorization: `Bearer ${token}`,
			}
		} : {});

		if (response.data.data) {
			setContent(response.data.data);
		}
	}

	useEffect(() => {
		fetchDoc()
	}, [langId]);

	return (
		<div className="user_manual_content_container">
			{content ? (
				<UserManualSearch
					content={content}
					contentClassName="ps-3 mt-5 pt-5 pb-5 mb-5"
				/>
			) : (
				<Container className="page-content">
					<Alert className="text-center" color="warning">
						{props.t("There is no data")}
					</Alert>
				</Container>
			)}
		</div>
	);
}

const mapStatetoProps = (state) => {
	const { user, token } = state.Login;
	const { App } = state;
	const organization = state.Organization;
	const { active: activeModule } = state.Modules;
	return { user, token, App, organization, activeModule };
};

export default connect(mapStatetoProps, {})(withNamespaces()(UserManual));
